import React from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { useWorkflowStore } from "../../store/useWorkflowStore";

/**
 * WorkflowDetailsForm component
 * 
 * Form for editing workflow name and description
 */
const WorkflowDetailsForm: React.FC = () => {
  const { 
    currentWorkflow,
    updateWorkflowName,
    updateWorkflowDescription
  } = useWorkflowStore();

  return (
    <div className="mb-8 border-b border-border pb-6">
      <h2 className="text-xl font-semibold text-foreground mb-4">Workflow Details</h2>
      <div className="space-y-4">
        <div className="grid w-full items-center gap-1.5">
          <Label htmlFor="workflow-name">Name</Label>
          <Input
            id="workflow-name"
            value={currentWorkflow?.name || ""}
            onChange={(e) => updateWorkflowName(e.target.value)}
            className="w-full"
            placeholder="Enter workflow name"
          />
        </div>
        <div className="grid w-full items-center gap-1.5">
          <Label htmlFor="workflow-description">Description</Label>
          <Textarea
            id="workflow-description"
            value={currentWorkflow?.description || ""}
            onChange={(e) => updateWorkflowDescription(e.target.value)}
            placeholder="Enter workflow description (optional)"
          />
        </div>
      </div>
    </div>
  );
};

export default WorkflowDetailsForm;
